import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import {
	ActionTypes,
	UserLicenseModel,
	cancelUserSubscriptionInvitation
} from 'store/account/subscription';

export function useSubscriptionCancelUserInvitation(): Operation<
	(userId: string, licenseModel: UserLicenseModel) => void
> {
	const dispatch = useDispatch();

	const [{ loading, error }] = useActivity(ActionTypes.CANCEL_SUBSCRIPTION_USER_INVITATION);

	function handler(userId: string, licenseModel: UserLicenseModel) {
		dispatch(cancelUserSubscriptionInvitation(userId, licenseModel));
	}

	return [{ loading, error }, handler];
}
